import React from 'react';

function About() {
  return (
    <section id="about" aria-labelledby="about">
      <div className="about-content revealable">
        <div className="about-layout">

          {/* Left column: Profile image */}
          <div className="profile-circle-flip">
            <img
              src="assets/profile02.jpg"
              alt="Abdulrahman Alamoudi – Finance and Investment Professional"
              className="profile-pic back"
            />
            <img
              src="assets/profile.jpg"
              alt="Abdulrahman Alamoudi – Finance and Investment Professional"
              className="profile-pic front"
            />
          </div>

          {/* Right column: Text */}
          <div className="about-text">
            <h2>About Abdulrahman Alamoudi</h2>
            <p>
              I am Abdulrahman Alamoudi, a finance professional with over seven years of experience across strategic finance, investment analysis, and M&A. I support businesses and stakeholders in making high-impact decisions through actionable insights grounded in data, valuation, and structured financial thinking.
            </p>
            <p>
              My work focuses on building financial models, valuation analyses, and decision frameworks that directly inform management decision-making, capital allocation, and long-term value creation across diverse market environments.
            </p>
            <p>
              I maintain strong academic and professional foundations through continuous learning, including certifications from Yale University, Bloomberg, and Rice University.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default About;